import { initData } from './initData';
import { initDistance } from './initDistance';

export const initializer = {
  initDistance,
  initData,
};
